export default "__VITE_ASSET__0bd486bc__$_?nuxt_component=async__"